<template>
  <main class="wrapper_full d-flex flex-column justify-center align-center py-8">
    <v-card width="500" max-width="95%" color="white" flat>
      <v-card width="100%" height="50" color="#277FAF" />
      <div class="pa-4 d-flex flex-column justify-center align-center">
        <svg
          width="252"
          height="367"
          viewBox="0 0 252 367"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M130.162 85.0836L19.8323 270.296C17.4089 274.361 20.5623 279.335 25.6136 279.375L244.32 281.165C249.375 281.206 252.638 276.25 250.255 272.144L141.878 85.1456C139.389 80.8465 132.709 80.8137 130.162 85.0836Z"
            fill="#277FAF"
          />
          <path
            d="M130.72 96.1505L30.5189 264.356C28.329 268.049 31.1941 272.567 35.7673 272.604L234.4 274.237C238.988 274.274 241.951 269.774 239.791 266.044L141.359 96.2052C139.097 92.2999 133.031 92.2816 130.72 96.1505Z"
            fill="#F2F2F2"
          />
          <path
            d="M141.389 217.492L143.999 129.9H126.101L128.711 217.492H141.389ZM135.05 254.9C141.762 254.9 146.05 249.973 146.05 243.587C146.05 237.017 141.762 232.273 135.05 232.273C128.711 232.273 124.05 237.017 124.05 243.587C124.05 249.973 128.525 254.9 135.05 254.9Z"
            fill="#277FAF"
          />
          <path
            d="M69.798 352.66C69.798 352.66 68.9586 357.4 68.5462 362.108C68.5093 362.543 68.5612 362.982 68.6986 363.397C68.836 363.812 69.0561 364.195 69.3457 364.523C69.6352 364.85 69.9882 365.116 70.3833 365.304C70.7785 365.492 71.2076 365.598 71.6448 365.615C77.9115 365.878 91.3136 366.385 96.1203 366.17C96.2899 366.162 96.4552 366.114 96.6021 366.029C96.749 365.944 96.8734 365.825 96.9647 365.682C97.0559 365.539 97.1114 365.376 97.1264 365.207C97.1415 365.038 97.1156 364.868 97.051 364.711V364.711C96.8251 364.149 96.393 363.694 95.8429 363.438L73.707 353.276L69.798 352.66Z"
            fill="#16558F"
          />
          <path
            d="M69.1079 349.87L69.7831 355.547C69.7831 355.547 73.6592 357.352 76.3089 355.321L74.6994 348.991L69.1079 349.87Z"
            fill="url(#paint0_linear)"
          />
          <path
            d="M69.6154 243.089C69.3234 244.573 68.0533 317.111 75.82 349.607C75.8853 349.864 75.8554 350.135 75.736 350.371C75.6166 350.607 75.4156 350.792 75.1704 350.891C73.1549 351.673 71.021 352.107 68.8599 352.175C68.4384 352.189 68.0241 352.063 67.6824 351.816C67.3407 351.569 67.0911 351.215 66.9729 350.811C64.7538 343.27 54.1256 305.486 52.7387 269.39C51.1876 229.061 52.7387 268.019 52.7387 268.019L53.6475 243.089H69.6154Z"
            fill="#343434"
          />
          <path
            d="M44.3297 355.135C44.3297 355.135 42.9939 357.531 41.7018 363.887C41.6451 364.158 41.6463 364.438 41.7052 364.709C41.7641 364.98 41.8794 365.235 42.0437 365.458C42.2079 365.682 42.4174 365.868 42.6584 366.005C42.8995 366.142 43.1668 366.226 43.4428 366.253C45.5086 366.458 48.6948 366.72 51.246 366.702C51.5228 366.701 51.7963 366.642 52.0487 366.529C52.3012 366.415 52.5268 366.25 52.711 366.043C52.8952 365.837 53.0338 365.594 53.1179 365.331C53.2019 365.067 53.2294 364.789 53.1987 364.514C52.914 362.188 52.0344 358.374 49.3153 355.398L44.3297 355.135Z"
            fill="#16558F"
          />
          <path
            d="M43.1582 347.832L44.7349 356.419C44.7349 356.419 46.2934 357.578 49.3738 356.736L48.6219 347.496L43.1582 347.832Z"
            fill="url(#paint1_linear)"
          />
          <path
            d="M38.8989 245.302C32.5519 283.589 40.2785 339.886 42.8808 350.906C42.9581 351.236 43.1313 351.536 43.3787 351.768C43.6261 352.001 43.9367 352.155 44.2714 352.211C45.9207 352.506 47.6145 352.439 49.2351 352.014C49.5537 351.921 49.8348 351.73 50.0385 351.468C50.2422 351.206 50.3583 350.887 50.3702 350.556C50.7352 341.644 50.0892 286.94 56.0018 265.321C56.3009 264.225 56.9718 263.267 57.8997 262.612L69.3783 254.458L70.2579 241.291L38.8989 245.302Z"
            fill="#313131"
          />
          <path
            d="M95.4087 190.766C94.4415 197.622 93.4232 199.197 92.6312 199.237C90.1129 199.368 90.6202 183.922 81.4081 176.093C75.5903 171.156 67.6411 170.748 61.4072 171.324L70.1339 202.599C71.4077 205.713 76.9444 218.311 89.4778 222.133C92.0326 222.913 95.8284 224.073 99.3614 222.556C106.333 219.562 109.603 207.292 106.486 191.926C105.019 191.383 102.989 190.807 95.4087 190.766Z"
            fill="#16558F"
          />
          <path
            d="M93.1855 164.031L94.3389 170.551C96.193 178.518 96.3682 185.162 95.4083 190.77C96.9996 190.836 98.6712 190.949 100.412 191.135C102.558 191.346 104.588 191.623 106.485 191.948C105.482 183.842 100.084 170.383 100.084 170.383C96.828 165.672 96.4412 168.728 93.1855 164.031Z"
            fill="url(#paint2_linear)"
          />
          <path
            d="M106.373 150.302C105.727 150.286 105.087 150.415 104.498 150.679C103.909 150.944 103.387 151.337 102.971 151.83L94.7445 161.57C94.7445 161.57 93.248 161.263 93.1057 158.397C92.9634 155.531 89.9194 155.188 89.9194 155.188C89.9194 155.188 90.3611 159.199 91.1969 165.096C91.675 168.48 93.6751 170.93 95.2992 172.443L100.044 170.806C104.424 164.571 107.121 157.697 108.628 150.364L106.373 150.302Z"
            fill="url(#paint3_linear)"
          />
          <path
            d="M28.8291 176.801C29.3802 176.658 33.1249 172.79 33.6906 172.684C42.9246 170.923 65.9803 164.72 81.408 176.093C81.4481 176.421 81.4737 176.684 81.4883 176.899C81.7266 177.248 81.9388 177.613 82.1234 177.993C83.6018 180.858 85.3455 183.577 87.3316 186.117C86.8864 186.556 86.5231 187.071 86.2586 187.638C82.5504 195.572 68.495 227.26 70.9659 246.64C70.9994 246.878 70.9858 247.119 70.9257 247.351C70.8657 247.583 70.7604 247.801 70.616 247.992C70.4716 248.184 70.2909 248.345 70.0841 248.466C69.8774 248.588 69.6487 248.667 69.4111 248.7C63.9547 249.455 47.7095 251.293 39.3149 247.829C39.0766 247.73 38.8734 247.563 38.7316 247.348C38.5897 247.132 38.5158 246.88 38.5193 246.622C38.574 242.731 38.4098 225.859 32.2198 205.52C31.988 204.761 31.7979 203.991 31.6504 203.212C31.5737 203.368 31.5007 203.525 31.4278 203.682L28.8291 176.801Z"
            fill="#16558F"
          />
          <path
            d="M42.9247 170.915C25.7014 172.173 22.1027 182.008 10.2007 175.995L12.3066 194.413C16.7192 199.281 23.3837 202.599 31.7819 203.842L42.9247 170.915Z"
            fill="#16558F"
          />
          <path
            d="M54.6951 154.27C51.7424 160.148 50.5124 166.135 50.1401 171.707C50.7752 171.944 59.2646 177.814 64.9182 172.13C63.7064 168.232 63.9072 162.361 64.2137 156.337L54.6951 154.27Z"
            fill="url(#paint4_linear)"
          />
          <path
            d="M70.0608 138.827C70.225 139.09 74.4405 159.035 74.4405 159.035L62.9875 161.223L56.166 142.915C56.166 142.915 67.3453 134.426 70.0608 138.827Z"
            fill="url(#paint5_linear)"
          />
          <path
            d="M60.5532 144.515C60.4019 144.723 60.2999 144.962 60.255 145.215C60.2101 145.467 60.2234 145.727 60.2941 145.974L63.0898 155.75C63.1314 155.898 63.1941 156.039 63.276 156.169C63.7285 156.899 65.349 159.086 67.5353 157.263C69.4003 155.735 71.134 154.346 72.6888 154.018C72.905 153.972 73.1282 153.969 73.3454 154.01C73.5627 154.051 73.7697 154.134 73.9546 154.255C74.1395 154.376 74.2986 154.532 74.4227 154.715C74.5469 154.898 74.6336 155.103 74.6779 155.32C75.3221 158.323 75.7429 161.37 75.9371 164.436C75.9549 164.853 75.8145 165.262 75.544 165.581C75.2734 165.9 74.8925 166.106 74.4772 166.157C72.2033 166.438 67.7433 166.853 64.0096 166.387C63.7089 166.349 63.4242 166.23 63.1857 166.043C62.9473 165.856 62.764 165.608 62.6555 165.325C61.6737 162.773 58.8998 155.699 57.8086 153.814C56.7939 152.067 54.0967 151.903 52.8594 151.925C52.6269 151.929 52.3961 151.885 52.1814 151.796C51.9666 151.707 51.7725 151.574 51.6112 151.407C50.6331 150.393 49.0563 148.096 51.7243 145.631C52.0402 145.331 52.2262 144.919 52.2425 144.484C52.2589 144.049 52.1044 143.624 51.8119 143.301C50.7389 142.094 49.7571 140.107 51.8119 137.864C53.8668 135.622 56.3851 136.008 57.991 136.657C58.3383 136.802 58.723 136.831 59.0879 136.739C59.4529 136.648 59.7786 136.441 60.0167 136.151C60.1316 135.996 60.2852 135.875 60.462 135.798C60.6389 135.722 60.8328 135.694 61.024 135.717C61.2391 135.736 61.4558 135.712 61.6614 135.646C61.8671 135.581 62.0577 135.475 62.2221 135.335C62.3865 135.195 62.5214 135.024 62.619 134.832C62.7166 134.639 62.7749 134.429 62.7905 134.214C62.9 132.643 63.6409 130.765 66.3746 130.094C71.3967 128.861 74.1742 133.806 74.2618 137.387C74.3494 140.967 68.8309 141.977 65.652 141.544C63.2978 141.23 61.4 143.363 60.5532 144.515Z"
            fill="#343434"
          />
          <path
            d="M59.5163 157.544C59.5163 157.544 58.4506 151.232 55.903 150.773C53.3555 150.313 50.7349 152.268 53.0708 155.878C55.9797 160.374 59.5163 157.544 59.5163 157.544Z"
            fill="url(#paint6_linear)"
          />
          <path
            d="M55.3157 134.816C55.8061 134.799 56.2966 134.845 56.7756 134.951C57.9837 135.206 59.5969 135.83 59.1772 136.993C58.5458 138.739 55.2756 137.106 53.531 139.91C51.998 142.393 53.2536 145.088 52.7828 147.761C52.5565 149.062 51.717 150.995 50.5564 151.753C50.0345 152.093 45.9284 152.745 45.7021 152.016L44.5598 148.311C43.5342 144.982 47.4796 139.436 49.5162 137.19C51.0856 135.483 53.2171 134.914 55.3157 134.816Z"
            fill="url(#paint7_linear)"
          />
          <path
            d="M51.4213 148.195L47.4942 151.476C39.9573 154.678 34.4827 158.452 30.5153 162.532C28.7614 159.196 26.1929 156.357 23.0479 154.277C30.6431 150.539 36.2966 148.986 36.2966 148.986C51.6257 142.813 51.4213 148.195 51.4213 148.195Z"
            fill="url(#paint8_linear)"
          />
          <path
            d="M30.5152 162.529C18.1278 175.291 21.7557 168.797 21.6499 179.667C21.6134 183.714 18.095 199.182 18.095 199.182C-19.7935 182.832 11.8246 160.53 23.0477 154.277C26.1923 156.356 28.7608 159.194 30.5152 162.529V162.529Z"
            fill="#16558F"
          />
          <path
            d="M99.5101 40.5238H91.3413V51.0447H80.0214V40.5238H53.0063V32.7249L76.6254 0.886963H88.8632L66.8963 31.0734H80.3579V21.6841H91.3413V31.0734H99.5101V40.5238Z"
            fill="#277FAF"
          />
          <path
            d="M102.967 25.9659C102.967 9.41995 112.146 0.0306582 124.383 7.42429e-05C136.621 -0.0305098 145.8 9.38936 145.8 25.9353C145.8 42.4812 136.621 51.8705 124.383 51.9011C112.146 51.9317 102.998 42.5118 102.967 25.9659ZM134.296 25.9659C134.296 14.5886 130.288 9.84812 124.475 9.84812C118.662 9.84812 114.716 14.5886 114.746 25.9965C114.777 37.4043 118.754 42.1142 124.475 42.1142C130.196 42.1142 134.296 37.3431 134.296 25.9353V25.9659Z"
            fill="#277FAF"
          />
          <path
            d="M197.627 40.4322H189.458V50.9837H178.107V40.4628H151.092V32.6638L174.711 0.825928H186.949L165.013 31.0735H178.505V21.5925H189.488V31.0735H197.657L197.627 40.4322Z"
            fill="#277FAF"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="69.1079"
              y1="352.638"
              x2="76.3089"
              y2="352.638"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint1_linear"
              x1="16847.8"
              y1="8895.18"
              x2="16953.6"
              y2="8895.18"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint2_linear"
              x1="21598.2"
              y1="157670"
              x2="23095.3"
              y2="164120"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint3_linear"
              x1="-10375.6"
              y1="209519"
              x2="-6791.84"
              y2="216006"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint4_linear"
              x1="-85500.9"
              y1="-2818.8"
              x2="-87313.2"
              y2="7.11884"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint5_linear"
              x1="67556.9"
              y1="7443.44"
              x2="70514.2"
              y2="7515.74"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint6_linear"
              x1="25616.5"
              y1="1185.37"
              x2="26764.5"
              y2="1299.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint7_linear"
              x1="52270.2"
              y1="23457"
              x2="50247.5"
              y2="24618"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
            <linearGradient
              id="paint8_linear"
              x1="101280"
              y1="22564.7"
              x2="99032.2"
              y2="25189.2"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA" />
              <stop offset="1" stop-color="#FF928E" />
            </linearGradient>
          </defs>
        </svg>
        <div class="f24 fw500 mt-5 mb-10">
          {{ localStorage.translations.pages.error.main['stranitsa-ne-naydena'] }}
        </div>
      </div>
    </v-card>
    <v-btn to="/" color="#277FAF" x-large class="white--text f16 mt-8">
      <v-icon class="mr-2">mdi-subdirectory-arrow-right mdi-rotate-180</v-icon>
      {{ localStorage.translations.pages.error.main['pereyti-na-glavnuyu'] }}
    </v-btn>
    <!--        <div class="error-page">-->
    <!--            <div class="box">-->
    <!--                <svg-->
    <!--                    width="300"-->
    <!--                    height="300"-->
    <!--                    viewBox="0 0 300 300"-->
    <!--                    fill="none"-->
    <!--                    xmlns="http://www.w3.org/2000/svg"-->
    <!--                >-->
    <!--                    <g clip-path="url(#clip0)">-->
    <!--                        <path-->
    <!--                            d="M295.592 56.8139V189.437L281.137 193.843H29.9692L4.40723 189.437V56.8139C4.40723 47.0822 12.2995 39.1841 22.037 39.1841H277.963C287.7 39.1841 295.592 47.0822 295.592 56.8139Z"-->
    <!--                            fill="#277FAF"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M39.6668 39.1841C29.9293 39.1841 22.037 47.0822 22.037 56.8139V189.437L18.0662 192.835H8.06364L4.40723 189.437V56.8139C4.40723 47.0822 12.2995 39.1841 22.037 39.1841H39.6668Z"-->
    <!--                            fill="#1E63A6"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M121.647 198.249H178.357V276.996H121.647V198.249Z"-->
    <!--                            fill="#E8EDF2"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M121.646 198.251H139.275V276.997H121.646V198.251Z"-->
    <!--                            fill="#D9E7EC"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M216.113 289.336H83.8894C78.0475 289.336 73.3115 284.6 73.3115 278.758V271.707C73.3115 265.865 78.0475 261.129 83.8894 261.129H216.113C221.955 261.129 226.691 265.865 226.691 271.707V278.758C226.691 284.601 221.955 289.336 216.113 289.336Z"-->
    <!--                            fill="#F5F8F9"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M295.592 189.437V210.005C295.592 219.742 287.7 227.635 277.963 227.635H22.037C12.2995 227.635 4.40723 219.742 4.40723 210.005V189.437H295.592Z"-->
    <!--                            fill="#F5F8F9"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M101.518 289.339H83.8884C78.0471 289.339 73.3105 284.602 73.3105 278.761V271.709C73.3105 265.868 78.0471 261.131 83.8884 261.131H101.518C95.6769 261.131 90.9403 265.868 90.9403 271.709V278.761C90.9403 284.602 95.6769 289.339 101.518 289.339Z"-->
    <!--                            fill="#E8EDF2"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M39.6668 227.635H22.037C12.2995 227.635 4.40723 219.742 4.40723 210.005V189.437H22.037V210.005C22.037 219.742 29.9293 227.635 39.6668 227.635Z"-->
    <!--                            fill="#E8EDF2"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M245.494 149.35V22.4152C245.494 15.9215 240.234 10.662 233.741 10.662H70.3713C63.8777 10.662 58.6182 15.9215 58.6182 22.4152V149.35H245.494Z"-->
    <!--                            fill="#F5F8F9"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M88.0011 10.662C81.5075 10.662 76.2479 15.9215 76.2479 22.4152V149.35H58.6182V22.4152C58.6182 15.9215 63.8777 10.662 70.3713 10.662H88.0011Z"-->
    <!--                            fill="#E8EDF2"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M277.963 34.4251H249.902V22.7718C249.902 13.8612 242.652 6.61121 233.741 6.61121H223.504C221.07 6.61121 219.097 8.58398 219.097 11.0186C219.097 13.4533 221.07 15.4261 223.504 15.4261H233.741C237.792 15.4261 241.087 18.7211 241.087 22.7718V145.299H63.0264V22.7718C63.0264 18.7211 66.3214 15.4261 70.3722 15.4261H202.936C205.371 15.4261 207.344 13.4533 207.344 11.0186C207.344 8.58398 205.371 6.61121 202.936 6.61121H70.3722C61.4615 6.61121 54.2116 13.8612 54.2116 22.7718V34.4251H22.0372C9.8856 34.4251 0 44.3107 0 56.4623V147.696C0 150.131 1.97277 152.104 4.40744 152.104C6.84212 152.104 8.81489 150.131 8.81489 147.696V56.4623C8.81489 49.1718 14.7467 43.24 22.0372 43.24H54.2116V145.299H46.2782C43.8435 145.299 41.8707 147.272 41.8707 149.706C41.8707 152.141 43.8435 154.114 46.2782 154.114H257.835C260.27 154.114 262.243 152.141 262.243 149.706C262.243 147.272 260.27 145.299 257.835 145.299H249.902V43.24H277.963C285.253 43.24 291.185 49.1718 291.185 56.4623V184.672H8.81489V168.264C8.81489 165.83 6.84212 163.857 4.40744 163.857C1.97277 163.857 0 165.83 0 168.264V209.647C0 221.799 9.8856 231.685 22.0372 231.685H117.238V256.366H83.8884C75.6253 256.366 68.903 263.089 68.903 271.352V278.404C68.903 286.667 75.6253 293.389 83.8884 293.389H216.112C224.375 293.389 231.097 286.667 231.097 278.404V271.352C231.097 263.089 224.375 256.366 216.112 256.366H182.762V231.685H277.963C290.114 231.685 300 221.799 300 209.647V56.4623C300 44.3107 290.114 34.4251 277.963 34.4251ZM222.282 271.352V278.404C222.282 281.806 219.514 284.574 216.112 284.574H83.8884C80.4858 284.574 77.7179 281.806 77.7179 278.404V271.352C77.7179 267.949 80.4858 265.181 83.8884 265.181H216.112C219.514 265.181 222.282 267.949 222.282 271.352ZM173.947 256.366H126.053V231.685H173.947V256.366ZM277.963 222.87H22.0372C14.7467 222.87 8.81489 216.938 8.81489 209.647V193.487H291.185V209.647C291.185 216.938 285.253 222.87 277.963 222.87Z"-->
    <!--                            fill="#BABABA"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M112.982 117.472H113.02C115.436 117.472 117.406 115.524 117.427 113.102C117.444 111.036 117.48 106.791 117.518 101.597H120.016C122.451 101.597 124.424 99.6241 124.424 97.1894C124.424 94.7548 122.451 92.782 120.016 92.782H117.577C117.659 79.4674 117.709 64.5932 117.546 62.6392C117.245 59.0263 115.122 56.0938 112.139 55.17C110.729 54.734 107.08 54.1722 103.658 58.3681C100.61 62.1074 85.3998 89.5892 82.381 95.0603C81.6282 96.4255 81.6523 98.0874 82.4451 99.4308C83.2378 100.773 84.6811 101.597 86.2402 101.597H108.702C108.672 105.649 108.642 109.551 108.612 113.027C108.591 115.461 110.547 117.451 112.982 117.472ZM93.7234 92.7826C99.7393 81.9808 105.817 71.323 108.823 66.459C108.862 71.5599 108.824 81.999 108.76 92.7826H93.7234Z"-->
    <!--                            fill="#BABABA"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M132.096 75.1229V99.9973C132.096 111.004 141.05 119.958 152.057 119.958C163.064 119.958 172.019 111.004 172.019 99.9973V75.1229C172.019 64.1166 163.064 55.1613 152.057 55.1613C141.05 55.1613 132.096 64.116 132.096 75.1229ZM163.204 75.1229V99.9973C163.204 106.143 158.204 111.143 152.057 111.143C145.911 111.143 140.911 106.143 140.911 99.9973V75.1229C140.911 68.9765 145.911 63.9761 152.057 63.9761C158.204 63.9761 163.204 68.9765 163.204 75.1229Z"-->
    <!--                            fill="#BABABA"-->
    <!--                        />-->
    <!--                        <path-->
    <!--                            d="M201.514 58.3693C198.467 62.1079 183.256 89.5898 180.237 95.0609C179.485 96.4261 179.509 98.088 180.302 99.4314C181.094 100.774 182.538 101.598 184.097 101.598H206.558C206.529 105.649 206.498 109.553 206.468 113.027C206.448 115.462 208.403 117.451 210.838 117.472H210.876C213.293 117.472 215.262 115.524 215.283 113.103C215.301 111.036 215.337 106.792 215.374 101.597H217.873C220.308 101.597 222.28 99.6247 222.28 97.19C222.28 94.7553 220.308 92.7826 217.873 92.7826H215.433C215.515 79.468 215.565 64.5937 215.402 62.6398C215.101 59.0269 212.978 56.0944 209.995 55.1706C208.584 54.7346 204.936 54.1716 201.514 58.3693ZM206.616 92.7826H191.58C197.596 81.9808 203.673 71.323 206.679 66.459C206.719 71.5599 206.68 81.999 206.616 92.7826Z"-->
    <!--                            fill="#BABABA"-->
    <!--                        />-->
    <!--                    </g>-->
    <!--                    <defs>-->
    <!--                        <clipPath id="clip0">-->
    <!--                            <rect width="300" height="300" fill="white" />-->
    <!--                        </clipPath>-->
    <!--                    </defs>-->
    <!--                </svg>-->

    <!--                <p class="error_text f16">-->
    <!--                    {{ localStorage.translations.pages.error.main['stranitsa-ne-naydena'] }}-->
    <!--                </p>-->
    <!--                <v-btn to="/" color="rgb(39, 127, 175)" class="error_button white&#45;&#45;text f16">-->
    <!--                    {{ localStorage.translations.pages.error.main['pereyti-na-glavnuyu'] }}-->
    <!--                </v-btn>-->
    <!--            </div>-->
    <!--        </div>-->
  </main>
</template>

<script>
export default {
  // props: ['error'],
  // head() {
  //   return {
  //     title: 'Ошибка ' + this.error.statusCode
  //   }
  // }
}
</script>

<style lang="scss" scoped>
//.error-page {
//    display: grid;
//    align-content: center;
//    align-items: center;
//    justify-content: center;
//    justify-items: center;
//    padding-top: 60px;
//    .box {
//        display: grid;
//        justify-content: center;
//        justify-items: center;
//        row-gap: 20px;
//    }
//}
.v-card {
  border-radius: 16px !important;

  .v-card {
    border-radius: 16px 16px 0 0 !important;
  }
}

.v-btn {
  border-radius: 16px !important;
}
</style>
